import * as React from 'react';
import { Image, useTheme } from '@nextui-org/react';
import { GetAssetsQuery } from '@src/generated/hooks';
import { AppFullWidthContainer } from '@src/layouts/app/AppFullWidthContainer';

interface AssetCardImageProps {
  asset: GetAssetsQuery['igAssets'][0];
}

/**
 * @name AssetCardImage
 * @description tbd...
 */
export function AssetCardImage(props: AssetCardImageProps) {
  const { asset } = props;

  // Hooks
  const { theme } = useTheme();

  // Setup
  const { proofUrl, screenshotUrl, videoUrl } = asset;
  const hasVideo = videoUrl !== undefined && videoUrl !== '';
  const hasScreenshot = screenshotUrl !== undefined && screenshotUrl !== '';
  const hasProof = proofUrl !== undefined && proofUrl !== '';

  return (
    <AppFullWidthContainer>
      {hasVideo && (
        <video
          controls
          style={{
            borderRadius: theme?.radii?.lg.value,
            objectFit: 'scale-down',
            width: '100%',
          }}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
      {!hasVideo && hasScreenshot && (
        <Image src={screenshotUrl} css={{ borderRadius: '$lg' }} />
      )}
      {!hasVideo && !hasScreenshot && hasProof && (
        <Image src={proofUrl} css={{ borderRadius: '$lg' }} />
      )}
    </AppFullWidthContainer>
  );
}
